import { render } from "./TopStudentsChart.vue?vue&type=template&id=3ae587ed&scoped=true"
import script from "./TopStudentsChart.vue?vue&type=script&lang=js"
export * from "./TopStudentsChart.vue?vue&type=script&lang=js"

import "./TopStudentsChart.vue?vue&type=style&index=0&id=3ae587ed&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ae587ed"

export default script